import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Client } from '../../models/client';
import { Person } from '../../models/person';
import { CompaniesService } from '../../services/companies.service';
import { PeopleService } from '../../services/people.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';
import { PagedPayload } from '../../models/paged-payload';
import { EnumService } from '../../services/enum.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lib-people-search-bar',
  templateUrl: './people-search-bar.component.html',
  styleUrls: ['./people-search-bar.component.css'],
  standalone: false
})
export class PeopleSearchBarComponent implements OnInit {
  // people, clients
  @Input() searchType: string;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  clientCode: string;
  hasSearched: boolean;
  items: any;
  minSearchLength = 2;
  maxResultSet = 5;
  searchQuery = '';
  showSearchResults = false;
  public employeeStatuses = [];

  constructor(
    private companyService: CompaniesService,
    private peopleService: PeopleService,
    private enumService: EnumService,
    private route: ActivatedRoute
  ) {
    this.search = _.debounce(this.search, 250);
  }

  ngOnInit() {
    this.clientCode = this.route.snapshot.paramMap.get('client_code');
    if (this.clientCode == null) {
      this.clientCode = this.route.parent.snapshot.paramMap.get('client_code');
    }
    // FIXME: below is temporary fix to allow searching for employee numbers < 10
    // when true searching is implemented, this will need to be refined
    this.minSearchLength = this.clientCode ? 1 : this.minSearchLength;
  }

  public displayPerson(item) {
    const middle = `${item.MiddleName?.trim() ? ` ${item.MiddleName.trim()} ` : ' '}`;
    const name = `${item.FirstName}${middle}${item.LastName}`;
    const status = `${this.employeeStatuses[item.CurrentStatus.StatusId]?.Value}`;
    const statusDate = `${new Date(item.CurrentStatus.DateStatusChange).toLocaleDateString()}`;

    return `${item.EmployeeId} - ${name} - ${status} since ${statusDate}`;
  }

  search(evt) {
    this.searchQuery = evt.target.value;
    // add 1 to maxResultSet. determines if 'View All Results' is shown
    this.peopleService
      .searchPeople(this.clientCode, {
        query: this.searchQuery,
        pageNumber: 1,
        perPage: this.maxResultSet + 1
      })
      .subscribe(data => {
        this._searchCallback(data);

        // fetch employee status information to be displayed.
        this.enumService
          .get('EmployeeStatuses')
          .pipe(map(data => (this.employeeStatuses = data)))
          .subscribe();
      });
  }

  showResults() {
    if (this.searchQuery && this.searchQuery.length >= this.minSearchLength) {
      this.showSearchResults = true;
    } else if (this.showSearchResults) {
      setTimeout(() => (this.showSearchResults = false), 250);
    }
  }

  private _searchCallback(data: PagedPayload<Client> | PagedPayload<Person>) {
    this.showResults();
    this.hasSearched = true;
    if (data && data.Items) {
      this.items = data.Items;
    } else {
      this.items = [];
    }
  }
}
